<template>
  <div class="fixed-column-select">
    <v-data-table
      :items="data.filter(x => x.show === true)"
      :items-per-page="25"
      :headers="headers"
      sort-by="nom"
      :sort-desc="false"
      dense
      :mobile-breakpoint="0"
      show-select
      :value="selected"
      @input="v => $emit('update:selected', v)"
      hide-default-footer
      :page.sync="page"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.nom="{ item }">
        <v-sheet width="250px">
          <v-text-field
            dense
            filled
            class="no-before"
            hide-details
            v-model="item.nom"
            @change="item.is_changed = true"
            :disabled="item.is_deleted"
          ></v-text-field>
        </v-sheet>
      </template>
      <template v-slot:item.order_number="{ item }">
        <v-text-field
          dense
          filled
          class="no-before"
          hide-details
          v-model="item.data.order_number"
          @change="item.is_changed = true"
          :disabled="item.is_deleted"
        ></v-text-field>
      </template>
      <template v-slot:item.product_key="{ item }">
        <v-sheet width="250px">
          <v-text-field
            dense
            filled
            class="no-before"
            hide-details
            v-model="item.data.product_key"
            @change="item.is_changed = true"
            :disabled="item.is_deleted"
          ></v-text-field>
        </v-sheet>
      </template>
      <template v-slot:item.tags="{ item }">
        <v-sheet width="700px">
          <v-text-field
            dense
            filled
            class="no-before"
            hide-details
            :value="item.data.tags.join(',')"
            @change="
              v => {
                item.data.tags = v.split(',');
                item.is_changed = true;
              }
            "
            :disabled="item.is_deleted"
          ></v-text-field>
        </v-sheet>
      </template>
      <template v-slot:item.allergens="{ item }">
        <v-sheet width="700px">
          <v-text-field
            dense
            filled
            class="no-before"
            hide-details
            :value="item.data.allergens.join(',')"
            @change="
              v => {
                item.data.allergens = v.split(',');
                item.is_changed = true;
              }
            "
            :disabled="item.is_deleted"
          ></v-text-field>
        </v-sheet>
      </template>
      <template v-slot:item.use_expiration_date="{ item }">
        <v-simple-checkbox
          :ripple="false"
          :value="item.use_expiration_date"
          @input="
            v => {
              item.use_expiration_date = v;
              item.is_changed = true;
            }
          "
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.expiration_date_timer="{ item }">
        <v-sheet width="100px">
          <j-decimal-input
            v-show="item.use_expiration_date === true"
            hide-details
            filled
            dense
            class="no-before"
            :value="item.expiration_date_timer"
            :min="0"
            :step="0"
            :decimal="0"
            @change="
              v => {
                item.expiration_date_timer = v;
                item.is_changed = true;
              }
            "
          ></j-decimal-input>
        </v-sheet>
      </template>
      <template v-slot:item.expiration_date_threshold="{ item }">
        <v-sheet width="100px">
          <j-decimal-input
            v-show="item.use_expiration_date === true"
            hide-details
            filled
            dense
            class="no-before"
            :value="item.expiration_date_threshold"
            :min="0"
            :step="0"
            :decimal="0"
            @change="
              v => {
                item.expiration_date_threshold = v;
                item.is_changed = true;
              }
            "
          ></j-decimal-input>
        </v-sheet>
      </template>
      <template v-slot:item.use_auto_expiration_waste="{ item }">
        <v-simple-checkbox
          :ripple="false"
          v-show="item.use_expiration_date === true"
          :value="item.use_auto_expiration_waste"
          @input="
            v => {
              item.use_auto_expiration_waste = v;
              item.is_changed = true;
            }
          "
        ></v-simple-checkbox>
      </template>
      <template v-slot:footer>
        <v-pagination
          color="accent"
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "ProductBulkEditorGrid",
  props: {
    data: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      page: 0,
      pageCount: 1,
      headers: [
        { value: "nom", text: "Nom" },
        { value: "order_number", text: "Numéro commande", width: 160 },
        { value: "product_key", text: "Clé d'intégration" },
        { value: "tags", text: "# (séparé avec , )", sortable: false },
        {
          value: "allergens",
          text: "Allergène (séparé avec , )",
          sortable: false
        },
        {
          value: "use_expiration_date",
          text: "Expiration",
          sortable: false
        },
        {
          value: "expiration_date_timer",
          text: "Jours avant expiration",
          sortable: false
        },
        {
          value: "expiration_date_threshold",
          text: "Jours avant alerte",
          sortable: false
        },
        {
          value: "use_auto_expiration_waste",
          text: "Perte automatique",
          sortable: false
        }
      ]
    };
  }
};
</script>

<style></style>
